module.exports = __webpack_public_path__ + "static/media/tick.d47426f5.wav";